import * as React from 'react';

import classnames from 'classnames';

import styles from './footer-bar.module.css';

type Props = {
    left?: React.ReactNode;
    center?: React.ReactNode;
    right?: React.ReactNode;
    hasBorder?: boolean;
    absolutePosition?: boolean;
    noPadding?: boolean;
    noMargin?: boolean;
    fitHeight?: boolean;
};

FooterBar.defaultProps = {
    left: <div />,
    center: null,
    right: <div />,
};

export function FooterBar(props: Props) {
    const styleName = classnames({
        [styles['footer-bar']]: !props.hasBorder,
        [styles['footer-bar--bordered']]: props.hasBorder,
        [styles['absolute-position']]: props.absolutePosition,
        [styles['no-padding']]: props.noPadding,
        [styles['fit-height']]: props.fitHeight,
        [styles['no-margin']]: props.noMargin,
    });

    return (
        <div className={styleName}>
            {props.left}
            {props.center}
            {props.right}
        </div>
    );
}
